import React, { ReactElement, MouseEvent } from "react"
import EditIcon from "@material-ui/icons/Edit"
import { Tooltip, IconButton } from "@material-ui/core"

/**
 * Prop definition for the IconEditButton
 *
 * @export
 * @interface ButtonProps
 */
export interface ButtonProps {
	onClick: (e: MouseEvent<HTMLButtonElement>) => void
}

/**
 * A abstraction for a Icon button used for deleting
 *
 * @export
 * @param {ButtonProps} {
 * 	onClick,
 * }
 * @returns {ReactElement}
 */
export default function IconEditButton({ onClick }: ButtonProps): ReactElement {
	return (
		<Tooltip title="Edit">
			<IconButton onClick={onClick}>
				<EditIcon />
				<span className="MuiTypography-srOnly">Edit data</span>
			</IconButton>
		</Tooltip>
	)
}
